import { IGetProjectResponseV2 } from 'app/models/projectModel';

/**
 * Checks if a project has environments with null type, indicating it can be converted
 * to Decoupled Deployment Model
 * @param project - The project data from API response
 * @returns boolean - true if project has environments and at least one has null type
 */
export const canConvertProject = (project: IGetProjectResponseV2): boolean => {
	if (
		!project?.environments?.length ||
		!Array.isArray(project.environments)
	) {
		return false;
	}

	return project.environments.some((env) => env.type === null);
};
